import {Component, OnInit} from '@angular/core';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import { properties } from 'src/environments/properties';
import {_windowUtil} from '../../../shared/utils/ui-utils';

declare let $: any;
declare let AB: any;

@Component({
    selector: 'app-cancel-freshpass-summary',
    templateUrl: './cancel-freshpass-summary.component.html',
    styleUrls: ['./cancel-freshpass-summary.component.scss'],
    providers: [SubscriptionService]
})
export class CancelFreshpassSummaryComponent implements OnInit {

    cancelReasonsData: any = {};
    userInfo: any;
    showLoader = true;
    cancelPlanResponse: any;
    currentEnvironment;
    userSubscriptionDetails: any;
    properties = properties
    isServiceError = false;
      public windowUtil = _windowUtil(window);

    constructor(public subscriptionService: SubscriptionService,
                public authService: AuthService,
                private activeRoute: ActivatedRoute,
                public router: Router,) {
        if (this.router.getCurrentNavigation()?.extras) {
            if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.userSubscriptionDetails) {
                this.userSubscriptionDetails = this.router.getCurrentNavigation().extras.state.userSubscriptionDetails;
            }
        }
    }

    ngOnInit(): void {
        if (this.activeRoute.data) {
            this.activeRoute.data.subscribe(data => {
                    let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                    if (isSessionValid) {
                        const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                        if (sessionData) {
                            this.userInfo = sessionData;
                            if(!this.userSubscriptionDetails) {
                                this.getSubscriptionDetails();
                            }else{
                                this.initSubscribes();
                            }
                        }
                    } else {
                        this.authService.redirectToSSO(data.tokenObject)
                    }
                },
                (err => {
                    this.authService.redirectToSSO({});
                }));
        }
    }

    initSubscribes() {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.checkUserSubscriptionDetails();
        this.subscriptionService.getCancelReasons(this.userInfo, this.currentEnvironment).subscribe((data) => {
            if (data && data.Data) {
                this.showLoader = false;
                this.cancelReasonsData = data;
            }
        });
    }
    getSubscriptionDetails() {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.subscriptionService.getUserSubscriptionDetails(this.userInfo, this.currentEnvironment).subscribe({
          next: (data) => {
            if (data && data?.Data) {
              this.userSubscriptionDetails = data.Data;
              if (this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
                this.showLoader = false;
                this.router.navigate([this.properties.urlPath.CONFIRMATION_PATH]);
              } else {
                this.showLoader = false;
                this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
              }
            }
          },
          error: (error) => {
            this.showLoader = false;
            this.isServiceError = true;
            this.handleErrorCode(error?.errorCode);
          },
          complete: () => {
            console.log('Subscription details retrieval completed.');
          }
        });
      }

    checkUserSubscriptionDetails() {
        if (this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
            this.router.navigate([this.properties.urlPath.CONFIRMATION_PATH]);
        }
        if (!this.userSubscriptionDetails) {
            this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
        }
    }

    cancelPlanResponseHandler(event) {
        this.cancelPlanResponse = event;
        if (this.cancelPlanResponse.status) {
            if (this.cancelPlanResponse && this.cancelPlanResponse.status) {
                let isTrial = '';
                let planType = '';
                if (this.cancelPlanResponse.status && this.cancelPlanResponse.status.toLowerCase() === 'trial') {
                    isTrial = properties.freshpassData.freeTrialTitle;
                }
                if (this.cancelPlanResponse.subscriptionType && this.cancelPlanResponse.subscriptionType.toLowerCase().indexOf('monthly') >= 0) {
                    planType = properties.cancelFreshpassSummary.monthlyFreshpass;
                } else {
                    planType = properties.cancelFreshpassSummary.annualFreshPass;
                }
                if (isTrial && isTrial.length > 0) {
                    AB.COMMON.userNotifyReloadPage(isTrial + ' - ' + planType + ': Your cancellation request has been processed.');
                } else {
                    if (this.cancelPlanResponse.status && this.cancelPlanResponse.status === 'Cancelled') {
                        AB.COMMON.userNotifyReloadPage('Your current FreshPass plan has been cancelled effective immediately per your request.');
                    } else {
                        AB.COMMON.userNotifyReloadPage(planType + ': Your cancellation request has been processed.');
                    }
                }
            }
            this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
          }
    }

    handleErrorCode(errorCode) {
      if (errorCode === properties.errorCode.INVALID_BANNER_CODE) {
        this.router.navigate([this.properties.urlPath.SUBSCRIBE_PATH]);
      } else {
        this.router.navigate([this.properties.urlPath.MANAGE_PLAN_PATH]);
      }
    }

}
